
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index8ZadoqBT9ioTje411rmUCMMLV3dt_WUVbDAYv7V_45Y2EMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/index.vue?macro=true";
import { default as loginF6huWem2mvXGghX7b5TJBtTA2fmNDDopdbYq8yD_45rXoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/login.vue?macro=true";
import { default as mgen9184JCqemT8E1CU_45HErAh1hE2G7Pl9jInIMgDTbr6loMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/mgen.vue?macro=true";
import { default as indexeTI8HrfbV8luUrNp2HZpXoNgSCYVbCDfVNgIzpTy7MkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/index.vue?macro=true";
import { default as notesQhY6LbCYOg8Fbm_450SQ8J9B5E5qxAdXRVAt5YsaDYxcQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/notes.vue?macro=true";
import { default as indexl8PBS4m60fLIs1wYq7dgYdG1dIHONVuS2uwhRVo4C7sMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/index.vue?macro=true";
import { default as en_45ce_45moment5vJMgDg5jInKppxT8XyOYX5QLcUBjbsaN2c4u3DjUQgMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/en-ce-moment.vue?macro=true";
import { default as plan_45du_45sitezAC0sava8MEAZ_hrwxfWRangFUNMAGtVYsyOSoxhVIoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/plan-du-site.vue?macro=true";
import { default as edityCqDBXmWvs56_45ttHlCgUVz5c6P41eoxSiyjeYJUKOOcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/edit.vue?macro=true";
import { default as places75_45PywawvjEVSWN6Ox_RHyjxA6ABWiOqoi1DD290eJcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/places.vue?macro=true";
import { default as accessibilitedpU_TaIZsue8VZEnbKHUX7PkJmgkdyZFE2mGVTPn4pcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/accessibilite.vue?macro=true";
import { default as _91id_93NuIRIX3XpEMYpr98dvXxPQ6Fe7B8qQCUIfXOAZSDwmkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/[id].vue?macro=true";
import { default as notificationsNnSRpm5j0VvKsrgwFtPo7LQp_45WGeNjH0oAdsRTVs9rwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/notifications.vue?macro=true";
import { default as indexO5kd7NnNCLuzq_45D_6fZgQJik_6eZ1NeSSWc66fxMuWAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/index.vue?macro=true";
import { default as indexa4bRqPYebhHw0QR7hhwNkj_45K6vSjpUjfxjMUXvCfaCUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/index.vue?macro=true";
import { default as _91slug_93QsFWjoLLFdbmGsp57KTX0XN8wpbupV0EpzIxvwY7QvoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/villes/[slug].vue?macro=true";
import { default as indexyYCAtVml1wzqjxep243znYHZfoh35ZDTGesYfJwhGKkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/index.vue?macro=true";
import { default as generiqueGFp8rt6WalCaBL1AjEC_450KPr2Jlwe6R8gciyINc28xIMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/generique.vue?macro=true";
import { default as _91slug_93c0TKSgP54rFlrRw4aDQw2TaWl8u_45n6m68XJsvK5J_roMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/reseaux/[slug].vue?macro=true";
import { default as missionslEyMjvZ5BSyVuVaNOtfSDlLwrL1ZMSkx6_ZwPuzLsQQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/missions.vue?macro=true";
import { default as indexe6kOyskmvgefCIMRgCkGqtaXVQF4GyDWi4jFoSwaIAQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/dashboard/index.vue?macro=true";
import { default as favorisuLgobRYv2cBfdqOcnwicoCQelp6l5YUFjj4_McatY14Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/favoris.vue?macro=true";
import { default as _91slug_93SDYVxqUfPtdg2LZP_NDazFZFLo_45TW1v9gTMxIJKghDEMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/activites/[slug].vue?macro=true";
import { default as logsL__45uFoKyAvgOJdr12N4cQEH_y6LnP1LH_C8VzSdZklYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/other/logs.vue?macro=true";
import { default as ressourcesGjIDQgL8J9t50Izf0GUcrcph7q5edF_453_wa0A1Th3XUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/ressources.vue?macro=true";
import { default as mentions_45legalesSSV7lFp3oqMlGJ8tBq_45tCdIYYHcXw2dChO_eQoli_ZEMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/mentions-legales.vue?macro=true";
import { default as missionsQdSzE4sX_ScmPJYAPVIGspDSezQvE9EPGaAipTGuuFwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/missions.vue?macro=true";
import { default as settings8U0XJLrDmdhQBGRff29DbU2mCFvTJfDFawLwKmE6KSwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/settings.vue?macro=true";
import { default as temoignagesPTi9y29oU7uazst_45l4xB7BlNgvEOI_459DXAHMr4JXs4cMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/temoignages.vue?macro=true";
import { default as index3dgNwxr0cjjnO80lFU6id0pchMt0W6sDjEdMCMzI3uMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/index.vue?macro=true";
import { default as admindlD3H5_oFjpPYDLa9Kn4apwnYNqQjTQeCwuMwSgv24IMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/maintenance/admin.vue?macro=true";
import { default as indexv6XgWgBzFPATWIbHuPh1biif3VJKuIJSHK_457DR5rqTIMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/maintenance/index.vue?macro=true";
import { default as index806A2HhTNa_45247RuJdQIYWBoyTxHCwracczKCqaY5g4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/territoires/index.vue?macro=true";
import { default as _91hash_93RTkcPoYGAyFpV8UOQCtdngRTqG_45jHy88HQ4jVIlCpboMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/invitations/[hash].vue?macro=true";
import { default as utilisateursrBlgALWIpTqO3u1G0iA7KwGRZbiMmYROiJLgsLuFBJAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/utilisateurs.vue?macro=true";
import { default as _91slug_935VGw7FfdcbTyxhWIr5uvMuNLBnc51uvSb_45otxOBWd_oMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/associations/[slug].vue?macro=true";
import { default as _91slug_93hO1RNqOYC_Bo76ythysyjWaJy_45XWd0riZEVLrI0NHrcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/departements/[slug].vue?macro=true";
import { default as indexNyvH_IUG6DELwHv7U0E5AQc_45BBr0I_b6jmLHeXRyxTQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/organisations/index.vue?macro=true";
import { default as preferencesWSwYQyxmIibLTWCxSoHKkLNY4mx44XnPbPXr18eJWcUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/preferences.vue?macro=true";
import { default as organisationsN1U4XJnYQ9mgC6j9YWf_45maeH_aJb4zBmZT9tidRvvtwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/organisations.vue?macro=true";
import { default as _91token_93kk2lmrIY1MRdQRCe_5evMaaC49I1TOtipd5oz6LaHSkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/temoignages/[token].vue?macro=true";
import { default as postsCMvGkLi_kowNSdoWxfruhexwQBfqhJpXqdYKzK2u3w4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/posts.vue?macro=true";
import { default as indexWFJNowIuyMGHLfhHBoFYjtd9yxY5IiRS2_huBTQotnoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/index.vue?macro=true";
import { default as addzeaRx6Icj_457LWBp9Iuw8t_45oYZNhO_Qbon_45xWpwOQmLUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/modeles/add.vue?macro=true";
import { default as _91slug_93lz48Li2Az86m43ifcMVJmt8AgbHzJ7Dsaf9PFcCXVGIMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/organisations/[slug].vue?macro=true";
import { default as indexlpSxZM6peYc9g_KgSm9TyY5lKsBGt9DrPH7kVVThie8Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/password-reset/index.vue?macro=true";
import { default as participationsVGdVeUw60CPKxstmjmQoKhMxsPk0M8SqlddyT1oXHIsMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/participations.vue?macro=true";
import { default as emailszS1rNk7MKvVTcOHML__451oFwvoP_BmC1kO_45FGyiNB0p4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/emails.vue?macro=true";
import { default as indexjFJnOqYDcCF9dQdpgQ7L0u_45hM6KjL28BK2K7RReUjsYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/alertes/index.vue?macro=true";
import { default as notificationsy81U_Kq5j34Nujfggjb2XDsxiSojD9P2tXGN7H2rz8sMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/notifications.vue?macro=true";
import { default as indexjAqePe_45ai_iKVWd_kDMC_45zWmbaEdJr2morma28r_45dccMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/index.vue?macro=true";
import { default as charte_45reserve_45civique_VJ9PD2FICJkIX27A_EWM8KvUw77fB1iDQ4mdHkfOSQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-reserve-civique.vue?macro=true";
import { default as _91slug_937SbEqkR17JHl1XmSMy4czVn5RUwDfyyLxnzYf17sApQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/domaines-action/[slug].vue?macro=true";
import { default as indexnE3oaAuAI68Rlk5WeuiPkX31ws5K814rB31BeSRLkBoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/modeles/index.vue?macro=true";
import { default as _91token_93XcPjUPY9IWymSciFmbyoJXHLry8bd0e_450EHtoEfw1XwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/password-reset/[token].vue?macro=true";
import { default as decembre_45ensemble9InEfnxK5dncwHrIxrtti3wvtZ_jemTgepzvO2cAl9wMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/decembre-ensemble.vue?macro=true";
import { default as invitationsG_bsyyyKKoR1DH72RYmI_45x1h7XR8X9Iws7JuEPU7rDQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/other/invitations.vue?macro=true";
import { default as messagesQPumQX9FbTUmuhOhPKSYh434Rc64TVMbUF_45cCeZSIn0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/messages.vue?macro=true";
import { default as placesV9jz61FGoDRq581GSlLW6NQHgQduHmPNF34bJ8vICZAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/places.vue?macro=true";
import { default as add2ohIxl5IY2URzcwMpAFrlE7hugiDoEprvUEjsHWb7NQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/add.vue?macro=true";
import { default as indexREyWQU8C2cJOwWULQ_45UvdPW6LXnQm1oJcjTxe15gEyMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/index.vue?macro=true";
import { default as index2YzJfy_Q98pDK148mxjsz56JXxgQs1sa8mg4g_HSFcIMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/index.vue?macro=true";
import { default as datesDtL_45XKNBQFgrmTCEZSLSiuV2m1pScKJpkaFjuMYTaLYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/dates.vue?macro=true";
import { default as indexSJcLkFthZ9yY_YeDvFVyaZCEdQ5rFW9Cv6GjsbXw320Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/index.vue?macro=true";
import { default as lieuxmTuTtTKZ6qmUcIvF217UxbHOn4jPEYRJA2_45UhW7T3joMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/lieux.vue?macro=true";
import { default as titlee6C6NlaFziBBP0wmLX9zYD__45gOOxCToEq5j8Xxd1V4EMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/title.vue?macro=true";
import { default as indexGwK7v2pI4lGp_OyLlVXBdy5AC_JxMUYxuKdFN3V_X2kMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/index.vue?macro=true";
import { default as missionseIc_OLAXWPocGvwlZXjRf_I0gPgF_45LAR7wCTfvv9_e0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/missions.vue?macro=true";
import { default as addMxP_2cQNunjaRYNeYPYpRUP6FoXQju6jSrfAlvuf2ZUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/add.vue?macro=true";
import { default as visuel0j3X6x9B9eNXOanhQARiq0UVcL6oG72uN9kHq0wA4yAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/visuel.vue?macro=true";
import { default as indexSSqM1lIUonDOPCjm_vg9zRgVRaOZyqojUcYAh_sPgpYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/participations/index.vue?macro=true";
import { default as indexH3k1MDeYd8sIDQIwV2kIm10b4aXtmy8IhIT2ZucqZd4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/index.vue?macro=true";
import { default as indexTPjq35hEjKRr37chmn3bgrTphLNWK_f08_455nIp7ntbcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/index.vue?macro=true";
import { default as addoiNO73pUR5iXCw5hhLyp_K1X2bgWZFrGcW0aSR9HTZwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/add.vue?macro=true";
import { default as adddgQdnS6r2s8yeLob_r3WPiJ6SITOoHjUSDkktaiHM08Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/add.vue?macro=true";
import { default as addRx4txiOQW0_RxZaTuaoIgh1XeBVPqZXvfHgaLKKiCrQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/add.vue?macro=true";
import { default as index_iXuC8w0GB_45BxSdE3JodI_c9r3rtstEurFox0gZ1CyEMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/index.vue?macro=true";
import { default as conversions6VCyqViKWDtzix86HocZ7Yu8n_RmkHKuoxPzI7G2YGsMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/conversions.vue?macro=true";
import { default as edit_ViTnFvBzPR_3GqxUOVEShUvHZHXw_rxFTheRbq0EfUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/[id]/edit.vue?macro=true";
import { default as politique_45de_45confidentialiteMsxVLH__45ao77lwEQKSoILD7gjO6nP_45wLIqySfbZPBv4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/politique-de-confidentialite.vue?macro=true";
import { default as indexmGT7iGe1DT9s_45CaRsxVuZJ4dnqk1Xn0vH_EPDP_45nTTwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/index.vue?macro=true";
import { default as add7rcmCY_450_fBpCECwZllFB9X2p7G_45_ZhMnqiNSl2VWYcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/add.vue?macro=true";
import { default as benevoles5cDTySUCPOd4G8fFn3yHVpKTMlP3_45nrdyy2HwHaAsxoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/benevoles.vue?macro=true";
import { default as editlpxdrAFoV7hftzkPeCtldS8apkwpf6XFBnMnWF6mCQkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/edit.vue?macro=true";
import { default as utilisateursjly1xgjV0lDonDXrcI2zItz_45DYZL1nE5rLwVTBLVUrwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/utilisateurs.vue?macro=true";
import { default as indexIXe9VwZygqGohgPkStpXOCn5dfuv2ulx6sRAa4UJIzcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/index.vue?macro=true";
import { default as indexN_45EWXUsOqMP2I7bjXPQfJ5k_GFXll83zMSRJY2lL9_45YMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/[id]/index.vue?macro=true";
import { default as indexOpvO0cH_veeCZ9Y5YW93rnX_45nIyScFn3QfhvpXVrT9MMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/index.vue?macro=true";
import { default as indexajC00Ng2M2n0v4XHw82YMaiu4BAPzaPHGC1ow2IRVUcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/[id]/index.vue?macro=true";
import { default as septembre_45pour_45apprendrey3voHAyrrAz00QGq8_45UPwA0uMV4d9WQ6slRoZuXdyi0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/septembre-pour-apprendre.vue?macro=true";
import { default as index0_n9NzVuId3p9O0F7vMaoXj4HuTqQP_45TMtXjl_45DV0zkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/index.vue?macro=true";
import { default as addUcmL1pyuxCh_45UrOmC6RHTDbgHItqve4E9v40XwBbvdQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/add.vue?macro=true";
import { default as indexdJ5BYEf3EzSyNoQG9FGXkGb8y2nskBUB9Kx9_d8tuvQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/index.vue?macro=true";
import { default as editxukmPHwhKl5LlWFO6NyzgFKa7ctB3ULNZD8bwFa4JqUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/[id]/edit.vue?macro=true";
import { default as _91slug_93x_45OUUK6K9KZls_3FPOXJbIWS_45LoK2dZndOdyK_rOYOMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/[id]/[slug].vue?macro=true";
import { default as printemps_45pour_45la_45planete9qDRCgBMkLLq5Gx_T_45yJx2s1QRDsI18W88Kpys73JR0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/printemps-pour-la-planete.vue?macro=true";
import { default as indexPIuU8p3bkdmy7pzD90y_45JY2EV48Xo76iev_45G0GxX1AYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/index.vue?macro=true";
import { default as participationsq18aRezx_45fqKkA7McohrfXeh758KvtBBluSAsz5jw2IMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/participations.vue?macro=true";
import { default as indexpCMLOgPKy4IitcoAMEqu5WEdeuE3G0vZHhrizCQ3OMYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/index.vue?macro=true";
import { default as activity_45logsAD1jZe29p_45caZK_6GNqeifrnh2YdBgbf6_NcGb_fjIsMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/referents/activity-logs.vue?macro=true";
import { default as editYbGj3jWUr5TxpSq7tRusznhhCSA8q6v2wI3y8yZXZR0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/[id]/edit.vue?macro=true";
import { default as index_n0N2SmWYy9jX7R2psco2H2s83v3XAujtI5itGUSunkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/index.vue?macro=true";
import { default as informationsjckpGA1sUIVkZbjwKkxekUeuu8vk2le71ct62SaHFyMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/informations.vue?macro=true";
import { default as responsablesVacq7mfxIn9vHKavoov79SAgjOYdSeC9FZUzVkQqVnMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/responsables.vue?macro=true";
import { default as editq9k8_45UT_7LOjm_Xa9ROoKAJXbxQ6vGXHDXX440RI9fQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/[id]/edit.vue?macro=true";
import { default as indexKvygiQ_lqcZU7iFxaj5ENz3aT6ewduW2D9H6BLzp5rsMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/[id]/index.vue?macro=true";
import { default as indexIfK5R2SEh4uQeK4ExbKpvFUVzUn95Qi0g_45z52E4QCBcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/testimonials/index.vue?macro=true";
import { default as indicateurs_45cles2_45gnLWg1jxUKW9YWjL4qIf4PmGC3oZYupU0rvBZNVnAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/indicateurs-cles.vue?macro=true";
import { default as editF6OmF02eLbxrefRn4W7_5lRoz6WAyMnMFp5vphYRPtMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/[id]/edit.vue?macro=true";
import { default as profileGVy_HYgsREYaw6ZtYBJRciVbT1wo_goktot3OpePfnUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/profile.vue?macro=true";
import { default as charte_45bon_45fonctionnementUKQRQ86rwp4_4bVK5w3g3VcWlAoTu2pxjbK6bxPfhVAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/charte-bon-fonctionnement.vue?macro=true";
import { default as waiting_45actionsBoaJpwxYuE5zBU52EpMLDV6iRXzfiadsq5RZlLbVkzYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/referents/waiting-actions.vue?macro=true";
import { default as editT3zH4BO1_45fVq_45PTXvQV2BSX_458uzBnR7VB11cvohD38UMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/[id]/edit.vue?macro=true";
import { default as addWCyMSYVD23s8fJhXmR3tFq1VzfQG0JGsG3wRn_45m_82sMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/add.vue?macro=true";
import { default as conditions_45generales_45d_45utilisationy6RUdDl9qU48eLPhDF7PHnx4B1KjO35DlP_45OUn26M4QMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/conditions-generales-d-utilisation.vue?macro=true";
import { default as indexRKDOonXb6O5CBwfz_CUhMDdDIMw5zbV2ELBAut_45CHZYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/[id]/index.vue?macro=true";
import { default as editforOk2lbNPGljrEegEOWJpHNQ5gJqhLHHdScDxHZYCwMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/[id]/edit.vue?macro=true";
import { default as diffusionsfNgFftvtmoX46hT1cQ7a_45JICMddO18ewU2tYMQ6S3ZoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/diffusions.vue?macro=true";
import { default as moderationsGT4sNt5lBqkYbc0UMB2KeZcNQFDscYxK92fhx2atiqsMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/suivis/moderations.vue?macro=true";
import { default as benevolesYcfKwSIScW_atiht7DhXZ4f54c7CCBwjV4pIg6c9lzoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/benevoles.vue?macro=true";
import { default as google_45api_45indexing9oza9jlsOIlPeyKbW2HCm60CnYEgBsZzkvAsSGXc1GYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/google-api-indexing.vue?macro=true";
import { default as index9YVUVsI0O5AYq7YWxsssRMby6ewMdy_45FzUAHpiZP4VQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/index.vue?macro=true";
import { default as editZOuGKo0N6qM9JwGQllW1BKegt1xvgEm1osxuUBaTSiEMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/[id]/edit.vue?macro=true";
import { default as indexAdHQubu65Evx90UkAhblpgmcdmIMauACsA3U8DfqK_45AMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/index.vue?macro=true";
import { default as profilej8zeIcCe7NX6Pcw6dW5eHTkL2KJce__gPl0dSWStAbkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/profile.vue?macro=true";
import { default as indexA7L9TTcJSVXK36Hd40lSVpEOyjgaeqEQq72jh6VkA30Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/[id]/index.vue?macro=true";
import { default as editDMcSJLrDr08tJM0LqPTRcTu1WRbBGVyI2thOyOE1AokMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/testimonials/[id]/edit.vue?macro=true";
import { default as addK1iA5ISCXTg8V490PQwQm7vckh57smChq71MwyyHpNcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/missions/add.vue?macro=true";
import { default as competencesoatSrHfwsbbNcOyMK256ChxyGsEAmNaVkr_4566EsXdPMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/competences.vue?macro=true";
import { default as preferenceszuXX17em5ewHgxDAgPzFBptFmtqANyY0cQQOOLgTuX4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/preferences.vue?macro=true";
import { default as search_45archived_45userszO3oxXhSz4gTPQmD_45CqlZi6fWo_zwRzG5dAcC2DqbxcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/search-archived-users.vue?macro=true";
import { default as doublons_45territoires_45CGJdErbtbpKhXX0mneVJ98LQcyZ4tAPGGvGqyz14UYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/contents/doublons-territoires.vue?macro=true";
import { default as responsablesjU7zTBILhadSK5sPcikmevz6_45iNkK18X5V92G4qoCcEMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/responsables.vue?macro=true";
import { default as transfert_45organisationqYDimMG_EGB0RGoJIi6b9gyhRq7pKaYegZGQ1i9wcwAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/transfert-organisation.vue?macro=true";
import { default as missions_45outdatedjz1xljI0AK30xXa7Ue3vES3ciiTwVNWiiZgFcEYkQZYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/responsables/missions-outdated.vue?macro=true";
import { default as pending_45items3F5pG7smnY3ctcIqxvBGZirDHzG_45YFyZaIjj1PZp6w8Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/[id]/pending-items.vue?macro=true";
import { default as user_45reset_45context_45rolebB8iTJLK4WY3rGrVBl_XD1OZzsTl9BRsIAeA7O_z9TMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/user-reset-context-role.vue?macro=true";
import { default as doublons_45organisationsNNyMYzZjEjvdkuNMdF7FNTcCv63RYH1u3ZN3aIx_45iAQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/contents/doublons-organisations.vue?macro=true";
import { default as edityJm7oYnZi_0FOADizzi8qc8sLXyVm04_Law17YNqLx0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/[id]/edit.vue?macro=true";
import { default as disponibilitesYGpxo9ejhS8OkGAonToQi4ypGiLkjOe6UGDpessNgFcMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/disponibilites.vue?macro=true";
import { default as user_45reset_45password_45linkPd5X_45GX2rw_6WXr5TljAchQV_v0BEG8PoLa8viCni98Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/user-reset-password-link.vue?macro=true";
import { default as index5fIhX7EWQD_8qOuxyx_45dZomeTTfdervLuCh8A0mNXQ0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/[id]/index.vue?macro=true";
import { default as collectivitezaJaQud9E0SVfwEyI7qAR3O1poMf47LPGjQZtd6WZHUMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/collectivite.vue?macro=true";
import { default as organisationhu7NKSZDHLoTwcxxKV6s5soubP5VndzDTPio89hmJb8Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation.vue?macro=true";
import { default as benevoles_45informationsmdcILwO2cDZVriAvVBp63BqznMfPKgpC82gaC7O70IkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/benevoles-informations.vue?macro=true";
import { default as trafic_45entrantp4c6iZYPm36fJdPzZRF2mMMQoHZDWnqwrNa8md9P8H0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/api-engagement/trafic-entrant.vue?macro=true";
import { default as trafic_45sortant8B_45tLvUP1I4SB5l8aLvtpTveE2Ch1U_450xzhjBNOgYckMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/api-engagement/trafic-sortant.vue?macro=true";
import { default as indexOclN_VZhhoRAlYGzsfEEYpFgKKjGsKV9927YoKI0OZ0Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/trouver-des-benevoles/index.vue?macro=true";
import { default as missions_45perimeesTEJPOd_45j8K8JZWtFRvQwusqk5npaph2covR824Qg3r8Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/missions-perimees.vue?macro=true";
import { default as missions_45a_45valider4INChrSydHfFj01mGOw2jzSPGVTVSATVSJDC_45OfUiBYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/missions-a-valider.vue?macro=true";
import { default as missions_45perimeescc8AqG6Eh4fyfX_5TX_45uxFpk0GUm3g2Lhc7uxXfBNVgMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/missions-perimees.vue?macro=true";
import { default as organisation_45images5PWFJ4Z3hSkRcYYhmxedBeJbZkFgc7h4CSinSHh2bkkMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-images.vue?macro=true";
import { default as organisation_45detailsFLVcADm9UiT6cbStcz4FnT3Hx7Bu8MwyNvQJu1ZXBCYMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-details.vue?macro=true";
import { default as participations_45to_45be_45treatedtFQF1O1hI3iXYtQXvCkKOWyxxaPqGUU9rgbYFbFCNOMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/responsables/participations-to-be-treated.vue?macro=true";
import { default as redirectfd7vAtPyrR00swl_0QnQPkX1Fpm_CqJgzYDt3hFRBhIMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue?macro=true";
import { default as organisations_45a_45validergy5rK4UTnBi3I6UmhzeiT6cJhyLTX3qk5PGN_2y3wtAMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/organisations-a-valider.vue?macro=true";
import { default as charte_45bon_45fonctionnementi25LwsicUPzZhU5CbQMf_45mEgYgwYcU7zpaQXrOUwDwMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/charte-bon-fonctionnement.vue?macro=true";
import { default as collectivite_45confirmationK2uTw2AXNUXU6_45UejSm4JzWgwBSQIstBldnUq3JhfhoMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/collectivite-confirmation.vue?macro=true";
import { default as organisation_45confirmationbAowtiMk2qhmilfc9MgOC8uwppfqc781pGMegy2yYnQMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-confirmation.vue?macro=true";
import { default as participations_45a_45valider4mrXE_45fh91A4OO6w0bYh1nD4yx0_UpCk9fENzIiX3O4Meta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/participations-a-valider.vue?macro=true";
import { default as participations_45refusees_45annuleesuOedgEZPp7H8pLdplwy9907tK8CK1JW9EpAmm_45wQwVMMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/participations-refusees-annulees.vue?macro=true";
import { default as component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w } from "/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    meta: loginF6huWem2mvXGghX7b5TJBtTA2fmNDDopdbYq8yD_45rXoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/login.vue")
  },
  {
    name: "quiz-mgen",
    path: "/quiz/mgen",
    meta: mgen9184JCqemT8E1CU_45HErAh1hE2G7Pl9jInIMgDTbr6loMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/mgen.vue")
  },
  {
    name: "admin",
    path: "/admin",
    meta: indexeTI8HrfbV8luUrNp2HZpXoNgSCYVbCDfVNgIzpTy7MkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/index.vue")
  },
  {
    name: "admin-notes",
    path: "/admin/notes",
    meta: notesQhY6LbCYOg8Fbm_450SQ8J9B5E5qxAdXRVAt5YsaDYxcQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/notes.vue")
  },
  {
    name: "stats",
    path: "/stats",
    meta: indexl8PBS4m60fLIs1wYq7dgYdG1dIHONVuS2uwhRVo4C7sMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/index.vue")
  },
  {
    name: "en-ce-moment",
    path: "/en-ce-moment",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/en-ce-moment.vue")
  },
  {
    name: "plan-du-site",
    path: "/plan-du-site",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/plan-du-site.vue")
  },
  {
    name: "profile-edit",
    path: "/profile/edit",
    meta: edityCqDBXmWvs56_45ttHlCgUVz5c6P41eoxSiyjeYJUKOOcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/edit.vue")
  },
  {
    name: "stats-places",
    path: "/stats/places",
    meta: places75_45PywawvjEVSWN6Ox_RHyjxA6ABWiOqoi1DD290eJcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/places.vue")
  },
  {
    name: "accessibilite",
    path: "/accessibilite",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/accessibilite.vue")
  },
  {
    name: "messages-id",
    path: "/messages/:id()",
    meta: _91id_93NuIRIX3XpEMYpr98dvXxPQ6Fe7B8qQCUIfXOAZSDwmkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/[id].vue")
  },
  {
    name: "notifications",
    path: "/notifications",
    meta: notificationsNnSRpm5j0VvKsrgwFtPo7LQp_45WGeNjH0oAdsRTVs9rwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/notifications.vue")
  },
  {
    name: "profile",
    path: "/profile",
    meta: indexO5kd7NnNCLuzq_45D_6fZgQJik_6eZ1NeSSWc66fxMuWAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/index.vue")
  },
  {
    name: "support",
    path: "/support",
    meta: indexa4bRqPYebhHw0QR7hhwNkj_45K6vSjpUjfxjMUXvCfaCUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/index.vue")
  },
  {
    name: "villes-slug",
    path: "/villes/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/villes/[slug].vue")
  },
  {
    name: "messages",
    path: "/messages",
    meta: indexyYCAtVml1wzqjxep243znYHZfoh35ZDTGesYfJwhGKkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/index.vue")
  },
  {
    name: "quiz-generique",
    path: "/quiz/generique",
    meta: generiqueGFp8rt6WalCaBL1AjEC_450KPr2Jlwe6R8gciyINc28xIMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/generique.vue")
  },
  {
    name: "reseaux-slug",
    path: "/reseaux/:slug()",
    meta: _91slug_93c0TKSgP54rFlrRw4aDQw2TaWl8u_45n6m68XJsvK5J_roMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/reseaux/[slug].vue")
  },
  {
    name: "stats-missions",
    path: "/stats/missions",
    meta: missionslEyMjvZ5BSyVuVaNOtfSDlLwrL1ZMSkx6_ZwPuzLsQQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/missions.vue")
  },
  {
    name: "dashboard",
    path: "/dashboard",
    meta: indexe6kOyskmvgefCIMRgCkGqtaXVQF4GyDWi4jFoSwaIAQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/dashboard/index.vue")
  },
  {
    name: "profile-favoris",
    path: "/profile/favoris",
    meta: favorisuLgobRYv2cBfdqOcnwicoCQelp6l5YUFjj4_McatY14Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/favoris.vue")
  },
  {
    name: "activites-slug",
    path: "/activites/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/activites/[slug].vue")
  },
  {
    name: "admin-other-logs",
    path: "/admin/other/logs",
    meta: logsL__45uFoKyAvgOJdr12N4cQEH_y6LnP1LH_C8VzSdZklYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/other/logs.vue")
  },
  {
    name: "admin-ressources",
    path: "/admin/ressources",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/ressources.vue")
  },
  {
    name: "mentions-legales",
    path: "/mentions-legales",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/mentions-legales.vue")
  },
  {
    name: "profile-missions",
    path: "/profile/missions",
    meta: missionsQdSzE4sX_ScmPJYAPVIGspDSezQvE9EPGaAipTGuuFwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/missions.vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    meta: settings8U0XJLrDmdhQBGRff29DbU2mCFvTJfDFawLwKmE6KSwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/settings.vue")
  },
  {
    name: "admin-temoignages",
    path: "/admin/temoignages",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/temoignages.vue")
  },
  {
    name: "inscription",
    path: "/inscription",
    meta: index3dgNwxr0cjjnO80lFU6id0pchMt0W6sDjEdMCMzI3uMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/index.vue")
  },
  {
    name: "maintenance-admin",
    path: "/maintenance/admin",
    meta: admindlD3H5_oFjpPYDLa9Kn4apwnYNqQjTQeCwuMwSgv24IMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/maintenance/admin.vue")
  },
  {
    name: "maintenance",
    path: "/maintenance",
    meta: indexv6XgWgBzFPATWIbHuPh1biif3VJKuIJSHK_457DR5rqTIMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/maintenance/index.vue")
  },
  {
    name: "territoires",
    path: "/territoires",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/territoires/index.vue")
  },
  {
    name: "invitations-hash",
    path: "/invitations/:hash()",
    meta: _91hash_93RTkcPoYGAyFpV8UOQCtdngRTqG_45jHy88HQ4jVIlCpboMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/invitations/[hash].vue")
  },
  {
    name: "stats-utilisateurs",
    path: "/stats/utilisateurs",
    meta: utilisateursrBlgALWIpTqO3u1G0iA7KwGRZbiMmYROiJLgsLuFBJAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/utilisateurs.vue")
  },
  {
    name: "associations-slug",
    path: "/associations/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/associations/[slug].vue")
  },
  {
    name: "departements-slug",
    path: "/departements/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/departements/[slug].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/organisations/index.vue")
  },
  {
    name: "profile-preferences",
    path: "/profile/preferences",
    meta: preferencesWSwYQyxmIibLTWCxSoHKkLNY4mx44XnPbPXr18eJWcUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/preferences.vue")
  },
  {
    name: "stats-organisations",
    path: "/stats/organisations",
    meta: organisationsN1U4XJnYQ9mgC6j9YWf_45maeH_aJb4zBmZT9tidRvvtwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/organisations.vue")
  },
  {
    name: "temoignages-token",
    path: "/temoignages/:token()",
    meta: _91token_93kk2lmrIY1MRdQRCe_5evMaaC49I1TOtipd5oz6LaHSkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/temoignages/[token].vue")
  },
  {
    name: "admin-contenus-posts",
    path: "/admin/contenus/posts",
    meta: postsCMvGkLi_kowNSdoWxfruhexwQBfqhJpXqdYKzK2u3w4Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/posts.vue")
  },
  {
    name: "admin-missions",
    path: "/admin/missions",
    meta: indexWFJNowIuyMGHLfhHBoFYjtd9yxY5IiRS2_huBTQotnoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/index.vue")
  },
  {
    name: "messages-modeles-add",
    path: "/messages/modeles/add",
    meta: addzeaRx6Icj_457LWBp9Iuw8t_45oYZNhO_Qbon_45xWpwOQmLUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/modeles/add.vue")
  },
  {
    name: "organisations-slug",
    path: "/organisations/:slug()",
    meta: _91slug_93lz48Li2Az86m43ifcMVJmt8AgbHzJ7Dsaf9PFcCXVGIMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/organisations/[slug].vue")
  },
  {
    name: "password-reset",
    path: "/password-reset",
    meta: indexlpSxZM6peYc9g_KgSm9TyY5lKsBGt9DrPH7kVVThie8Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/password-reset/index.vue")
  },
  {
    name: "stats-participations",
    path: "/stats/participations",
    meta: participationsVGdVeUw60CPKxstmjmQoKhMxsPk0M8SqlddyT1oXHIsMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/stats/participations.vue")
  },
  {
    name: "admin-settings-emails",
    path: "/admin/settings/emails",
    meta: emailszS1rNk7MKvVTcOHML__451oFwvoP_BmC1kO_45FGyiNB0p4Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/emails.vue")
  },
  {
    name: "profile-alertes",
    path: "/profile/alertes",
    meta: indexjFJnOqYDcCF9dQdpgQ7L0u_45hM6KjL28BK2K7RReUjsYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/alertes/index.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    meta: notificationsy81U_Kq5j34Nujfggjb2XDsxiSojD9P2tXGN7H2rz8sMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/notifications.vue")
  },
  {
    name: "admin-statistics",
    path: "/admin/statistics",
    meta: indexjAqePe_45ai_iKVWd_kDMC_45zWmbaEdJr2morma28r_45dccMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/index.vue")
  },
  {
    name: "charte-reserve-civique",
    path: "/charte-reserve-civique",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-reserve-civique.vue")
  },
  {
    name: "domaines-action-slug",
    path: "/domaines-action/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/domaines-action/[slug].vue")
  },
  {
    name: "messages-modeles",
    path: "/messages/modeles",
    meta: indexnE3oaAuAI68Rlk5WeuiPkX31ws5K814rB31BeSRLkBoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/messages/modeles/index.vue")
  },
  {
    name: "password-reset-token",
    path: "/password-reset/:token()",
    meta: _91token_93XcPjUPY9IWymSciFmbyoJXHLry8bd0e_450EHtoEfw1XwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/password-reset/[token].vue")
  },
  {
    name: "quiz-decembre-ensemble",
    path: "/quiz/decembre-ensemble",
    meta: decembre_45ensemble9InEfnxK5dncwHrIxrtti3wvtZ_jemTgepzvO2cAl9wMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/decembre-ensemble.vue")
  },
  {
    name: "admin-other-invitations",
    path: "/admin/other/invitations",
    meta: invitationsG_bsyyyKKoR1DH72RYmI_45x1h7XR8X9Iws7JuEPU7rDQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/other/invitations.vue")
  },
  {
    name: "admin-settings-messages",
    path: "/admin/settings/messages",
    meta: messagesQPumQX9FbTUmuhOhPKSYh434Rc64TVMbUF_45cCeZSIn0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/messages.vue")
  },
  {
    name: "admin-statistics-places",
    path: "/admin/statistics/places",
    meta: placesV9jz61FGoDRq581GSlLW6NQHgQduHmPNF34bJ8vICZAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/places.vue")
  },
  {
    name: "admin-settings-rules-add",
    path: "/admin/settings/rules/add",
    meta: add2ohIxl5IY2URzcwMpAFrlE7hugiDoEprvUEjsHWb7NQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/add.vue")
  },
  {
    name: "admin-utilisateurs",
    path: "/admin/utilisateurs",
    meta: indexREyWQU8C2cJOwWULQ_45UvdPW6LXnQm1oJcjTxe15gEyMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/index.vue")
  },
  {
    name: "missions-benevolat",
    path: "/missions-benevolat",
    meta: index2YzJfy_Q98pDK148mxjsz56JXxgQs1sa8mg4g_HSFcIMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/index.vue")
  },
  {
    name: "admin-missions-id-dates",
    path: "/admin/missions/:id()/dates",
    meta: datesDtL_45XKNBQFgrmTCEZSLSiuV2m1pScKJpkaFjuMYTaLYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/dates.vue")
  },
  {
    name: "admin-missions-id",
    path: "/admin/missions/:id()",
    meta: indexSJcLkFthZ9yY_YeDvFVyaZCEdQ5rFW9Cv6GjsbXw320Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/index.vue")
  },
  {
    name: "admin-missions-id-lieux",
    path: "/admin/missions/:id()/lieux",
    meta: lieuxmTuTtTKZ6qmUcIvF217UxbHOn4jPEYRJA2_45UhW7T3joMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/lieux.vue")
  },
  {
    name: "admin-missions-id-title",
    path: "/admin/missions/:id()/title",
    meta: titlee6C6NlaFziBBP0wmLX9zYD__45gOOxCToEq5j8Xxd1V4EMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/title.vue")
  },
  {
    name: "admin-organisations",
    path: "/admin/organisations",
    meta: indexGwK7v2pI4lGp_OyLlVXBdy5AC_JxMUYxuKdFN3V_X2kMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/index.vue")
  },
  {
    name: "admin-statistics-missions",
    path: "/admin/statistics/missions",
    meta: missionseIc_OLAXWPocGvwlZXjRf_I0gPgF_45LAR7wCTfvv9_e0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/missions.vue")
  },
  {
    name: "admin-contenus-reseaux-add",
    path: "/admin/contenus/reseaux/add",
    meta: addMxP_2cQNunjaRYNeYPYpRUP6FoXQju6jSrfAlvuf2ZUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/add.vue")
  },
  {
    name: "admin-missions-id-visuel",
    path: "/admin/missions/:id()/visuel",
    meta: visuel0j3X6x9B9eNXOanhQARiq0UVcL6oG72uN9kHq0wA4yAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/visuel.vue")
  },
  {
    name: "admin-participations",
    path: "/admin/participations",
    meta: indexSSqM1lIUonDOPCjm_vg9zRgVRaOZyqojUcYAh_sPgpYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/participations/index.vue")
  },
  {
    name: "admin-settings-rules",
    path: "/admin/settings/rules",
    meta: indexH3k1MDeYd8sIDQIwV2kIm10b4aXtmy8IhIT2ZucqZd4Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/index.vue")
  },
  {
    name: "inscription-benevole",
    path: "/inscription/benevole",
    meta: indexTPjq35hEjKRr37chmn3bgrTphLNWK_f08_455nIp7ntbcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/index.vue")
  },
  {
    name: "admin-contenus-domaines-add",
    path: "/admin/contenus/domaines/add",
    meta: addoiNO73pUR5iXCw5hhLyp_K1X2bgWZFrGcW0aSR9HTZwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/add.vue")
  },
  {
    name: "admin-taxonomies-slug-add",
    path: "/admin/taxonomies/:slug()/add",
    meta: adddgQdnS6r2s8yeLob_r3WPiJ6SITOoHjUSDkktaiHM08Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/add.vue")
  },
  {
    name: "admin-contenus-activites-add",
    path: "/admin/contenus/activites/add",
    meta: addRx4txiOQW0_RxZaTuaoIgh1XeBVPqZXvfHgaLKKiCrQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/add.vue")
  },
  {
    name: "admin-contenus-reseaux",
    path: "/admin/contenus/reseaux",
    meta: index_iXuC8w0GB_45BxSdE3JodI_c9r3rtstEurFox0gZ1CyEMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/index.vue")
  },
  {
    name: "admin-statistics-conversions",
    path: "/admin/statistics/conversions",
    meta: conversions6VCyqViKWDtzix86HocZ7Yu8n_RmkHKuoxPzI7G2YGsMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/conversions.vue")
  },
  {
    name: "admin-utilisateurs-id-edit",
    path: "/admin/utilisateurs/:id()/edit",
    meta: edit_ViTnFvBzPR_3GqxUOVEShUvHZHXw_rxFTheRbq0EfUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/[id]/edit.vue")
  },
  {
    name: "politique-de-confidentialite",
    path: "/politique-de-confidentialite",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/politique-de-confidentialite.vue")
  },
  {
    name: "admin-contenus-domaines",
    path: "/admin/contenus/domaines",
    meta: indexmGT7iGe1DT9s_45CaRsxVuZJ4dnqk1Xn0vH_EPDP_45nTTwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/index.vue")
  },
  {
    name: "admin-contenus-ressources-add",
    path: "/admin/contenus/ressources/add",
    meta: add7rcmCY_450_fBpCECwZllFB9X2p7G_45_ZhMnqiNSl2VWYcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/add.vue")
  },
  {
    name: "admin-missions-id-benevoles",
    path: "/admin/missions/:id()/benevoles",
    meta: benevoles5cDTySUCPOd4G8fFn3yHVpKTMlP3_45nrdyy2HwHaAsxoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/benevoles.vue")
  },
  {
    name: "admin-organisations-id-edit",
    path: "/admin/organisations/:id()/edit",
    meta: editlpxdrAFoV7hftzkPeCtldS8apkwpf6XFBnMnWF6mCQkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/edit.vue")
  },
  {
    name: "admin-statistics-utilisateurs",
    path: "/admin/statistics/utilisateurs",
    meta: utilisateursjly1xgjV0lDonDXrcI2zItz_45DYZL1nE5rLwVTBLVUrwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/utilisateurs.vue")
  },
  {
    name: "admin-taxonomies-slug",
    path: "/admin/taxonomies/:slug()",
    meta: indexIXe9VwZygqGohgPkStpXOCn5dfuv2ulx6sRAa4UJIzcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/index.vue")
  },
  {
    name: "admin-utilisateurs-id",
    path: "/admin/utilisateurs/:id()",
    meta: indexN_45EWXUsOqMP2I7bjXPQfJ5k_GFXll83zMSRJY2lL9_45YMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/utilisateurs/[id]/index.vue")
  },
  {
    name: "inscription-responsable",
    path: "/inscription/responsable",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/index.vue")
  },
  {
    name: "missions-benevolat-id",
    path: "/missions-benevolat/:id()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/[id]/index.vue")
  },
  {
    name: "quiz-septembre-pour-apprendre",
    path: "/quiz/septembre-pour-apprendre",
    meta: septembre_45pour_45apprendrey3voHAyrrAz00QGq8_45UPwA0uMV4d9WQ6slRoZuXdyi0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/septembre-pour-apprendre.vue")
  },
  {
    name: "admin-contenus-activites",
    path: "/admin/contenus/activites",
    meta: index0_n9NzVuId3p9O0F7vMaoXj4HuTqQP_45TMtXjl_45DV0zkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/index.vue")
  },
  {
    name: "admin-contenus-territoires-add",
    path: "/admin/contenus/territoires/add",
    meta: addUcmL1pyuxCh_45UrOmC6RHTDbgHItqve4E9v40XwBbvdQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/add.vue")
  },
  {
    name: "admin-organisations-id",
    path: "/admin/organisations/:id()",
    meta: indexdJ5BYEf3EzSyNoQG9FGXkGb8y2nskBUB9Kx9_d8tuvQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/index.vue")
  },
  {
    name: "admin-settings-rules-id-edit",
    path: "/admin/settings/rules/:id()/edit",
    meta: editxukmPHwhKl5LlWFO6NyzgFKa7ctB3ULNZD8bwFa4JqUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/[id]/edit.vue")
  },
  {
    name: "missions-benevolat-id-slug",
    path: "/missions-benevolat/:id()/:slug()",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/missions-benevolat/[id]/[slug].vue")
  },
  {
    name: "quiz-printemps-pour-la-planete",
    path: "/quiz/printemps-pour-la-planete",
    meta: printemps_45pour_45la_45planete9qDRCgBMkLLq5Gx_T_45yJx2s1QRDsI18W88Kpys73JR0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/quiz/printemps-pour-la-planete.vue")
  },
  {
    name: "admin-contenus-ressources",
    path: "/admin/contenus/ressources",
    meta: indexPIuU8p3bkdmy7pzD90y_45JY2EV48Xo76iev_45G0GxX1AYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/index.vue")
  },
  {
    name: "admin-statistics-participations",
    path: "/admin/statistics/participations",
    meta: participationsq18aRezx_45fqKkA7McohrfXeh758KvtBBluSAsz5jw2IMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/participations.vue")
  },
  {
    name: "charte-bon-fonctionnement",
    path: "/charte-bon-fonctionnement",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/index.vue")
  },
  {
    name: "support-referents-activity-logs",
    path: "/support/referents/activity-logs",
    meta: activity_45logsAD1jZe29p_45caZK_6GNqeifrnh2YdBgbf6_NcGb_fjIsMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/referents/activity-logs.vue")
  },
  {
    name: "admin-contenus-reseaux-id-edit",
    path: "/admin/contenus/reseaux/:id()/edit",
    meta: editYbGj3jWUr5TxpSq7tRusznhhCSA8q6v2wI3y8yZXZR0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/[id]/edit.vue")
  },
  {
    name: "admin-contenus-territoires",
    path: "/admin/contenus/territoires",
    meta: index_n0N2SmWYy9jX7R2psco2H2s83v3XAujtI5itGUSunkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/index.vue")
  },
  {
    name: "admin-missions-id-informations",
    path: "/admin/missions/:id()/informations",
    meta: informationsjckpGA1sUIVkZbjwKkxekUeuu8vk2le71ct62SaHFyMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/informations.vue")
  },
  {
    name: "admin-missions-id-responsables",
    path: "/admin/missions/:id()/responsables",
    meta: responsablesVacq7mfxIn9vHKavoov79SAgjOYdSeC9FZUzVkQqVnMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/responsables.vue")
  },
  {
    name: "admin-contenus-domaines-id-edit",
    path: "/admin/contenus/domaines/:id()/edit",
    meta: editq9k8_45UT_7LOjm_Xa9ROoKAJXbxQ6vGXHDXX440RI9fQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/domaines/[id]/edit.vue")
  },
  {
    name: "admin-contenus-reseaux-id",
    path: "/admin/contenus/reseaux/:id()",
    meta: indexKvygiQ_lqcZU7iFxaj5ENz3aT6ewduW2D9H6BLzp5rsMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/reseaux/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials",
    path: "/admin/contenus/testimonials",
    meta: indexIfK5R2SEh4uQeK4ExbKpvFUVzUn95Qi0g_45z52E4QCBcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/testimonials/index.vue")
  },
  {
    name: "admin-statistics-indicateurs-cles",
    path: "/admin/statistics/indicateurs-cles",
    meta: indicateurs_45cles2_45gnLWg1jxUKW9YWjL4qIf4PmGC3oZYupU0rvBZNVnAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/indicateurs-cles.vue")
  },
  {
    name: "admin-taxonomies-slug-id-edit",
    path: "/admin/taxonomies/:slug()/:id()/edit",
    meta: editF6OmF02eLbxrefRn4W7_5lRoz6WAyMnMFp5vphYRPtMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/taxonomies/[slug]/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-profile",
    path: "/inscription/benevole/step/profile",
    meta: profileGVy_HYgsREYaw6ZtYBJRciVbT1wo_goktot3OpePfnUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/profile.vue")
  },
  {
    name: "profile-charte-bon-fonctionnement",
    path: "/profile/charte-bon-fonctionnement",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/profile/charte-bon-fonctionnement.vue")
  },
  {
    name: "support-referents-waiting-actions",
    path: "/support/referents/waiting-actions",
    meta: waiting_45actionsBoaJpwxYuE5zBU52EpMLDV6iRXzfiadsq5RZlLbVkzYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/referents/waiting-actions.vue")
  },
  {
    name: "admin-contenus-activites-id-edit",
    path: "/admin/contenus/activites/:id()/edit",
    meta: editT3zH4BO1_45fVq_45PTXvQV2BSX_458uzBnR7VB11cvohD38UMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/[id]/edit.vue")
  },
  {
    name: "admin-contenus-modeles-mission-add",
    path: "/admin/contenus/modeles-mission/add",
    meta: addWCyMSYVD23s8fJhXmR3tFq1VzfQG0JGsG3wRn_45m_82sMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/add.vue")
  },
  {
    name: "conditions-generales-d-utilisation",
    path: "/conditions-generales-d-utilisation",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/conditions-generales-d-utilisation.vue")
  },
  {
    name: "admin-contenus-activites-id",
    path: "/admin/contenus/activites/:id()",
    meta: indexRKDOonXb6O5CBwfz_CUhMDdDIMw5zbV2ELBAut_45CHZYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/activites/[id]/index.vue")
  },
  {
    name: "admin-contenus-ressources-id-edit",
    path: "/admin/contenus/ressources/:id()/edit",
    meta: editforOk2lbNPGljrEegEOWJpHNQ5gJqhLHHdScDxHZYCwMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/ressources/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-diffusions",
    path: "/admin/organisations/:id()/diffusions",
    meta: diffusionsfNgFftvtmoX46hT1cQ7a_45JICMddO18ewU2tYMQ6S3ZoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/diffusions.vue")
  },
  {
    name: "admin-statistics-suivis-moderations",
    path: "/admin/statistics/suivis/moderations",
    meta: moderationsGT4sNt5lBqkYbc0UMB2KeZcNQFDscYxK92fhx2atiqsMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/suivis/moderations.vue")
  },
  {
    name: "charte-bon-fonctionnement-benevoles",
    path: "/charte-bon-fonctionnement/benevoles",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/benevoles.vue")
  },
  {
    name: "support-actions-google-api-indexing",
    path: "/support/actions/google-api-indexing",
    meta: google_45api_45indexing9oza9jlsOIlPeyKbW2HCm60CnYEgBsZzkvAsSGXc1GYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/google-api-indexing.vue")
  },
  {
    name: "admin-contenus-modeles-mission",
    path: "/admin/contenus/modeles-mission",
    meta: index9YVUVsI0O5AYq7YWxsssRMby6ewMdy_45FzUAHpiZP4VQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/index.vue")
  },
  {
    name: "admin-contenus-territoires-id-edit",
    path: "/admin/contenus/territoires/:id()/edit",
    meta: editZOuGKo0N6qM9JwGQllW1BKegt1xvgEm1osxuUBaTSiEMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/[id]/edit.vue")
  },
  {
    name: "admin-statistics-organisations",
    path: "/admin/statistics/organisations",
    meta: indexAdHQubu65Evx90UkAhblpgmcdmIMauACsA3U8DfqK_45AMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/index.vue")
  },
  {
    name: "inscription-responsable-step-profile",
    path: "/inscription/responsable/step/profile",
    meta: profilej8zeIcCe7NX6Pcw6dW5eHTkL2KJce__gPl0dSWStAbkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/profile.vue")
  },
  {
    name: "admin-contenus-territoires-id",
    path: "/admin/contenus/territoires/:id()",
    meta: indexA7L9TTcJSVXK36Hd40lSVpEOyjgaeqEQq72jh6VkA30Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/territoires/[id]/index.vue")
  },
  {
    name: "admin-contenus-testimonials-id-edit",
    path: "/admin/contenus/testimonials/:id()/edit",
    meta: editDMcSJLrDr08tJM0LqPTRcTu1WRbBGVyI2thOyOE1AokMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/testimonials/[id]/edit.vue")
  },
  {
    name: "admin-organisations-id-missions-add",
    path: "/admin/organisations/:id()/missions/add",
    meta: addK1iA5ISCXTg8V490PQwQm7vckh57smChq71MwyyHpNcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/organisations/[id]/missions/add.vue")
  },
  {
    name: "inscription-benevole-step-competences",
    path: "/inscription/benevole/step/competences",
    meta: competencesoatSrHfwsbbNcOyMK256ChxyGsEAmNaVkr_4566EsXdPMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/competences.vue")
  },
  {
    name: "inscription-benevole-step-preferences",
    path: "/inscription/benevole/step/preferences",
    meta: preferenceszuXX17em5ewHgxDAgPzFBptFmtqANyY0cQQOOLgTuX4Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/preferences.vue")
  },
  {
    name: "support-actions-search-archived-users",
    path: "/support/actions/search-archived-users",
    meta: search_45archived_45userszO3oxXhSz4gTPQmD_45CqlZi6fWo_zwRzG5dAcC2DqbxcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/search-archived-users.vue")
  },
  {
    name: "support-contents-doublons-territoires",
    path: "/support/contents/doublons-territoires",
    meta: doublons_45territoires_45CGJdErbtbpKhXX0mneVJ98LQcyZ4tAPGGvGqyz14UYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/contents/doublons-territoires.vue")
  },
  {
    name: "charte-bon-fonctionnement-responsables",
    path: "/charte-bon-fonctionnement/responsables",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/charte-bon-fonctionnement/responsables.vue")
  },
  {
    name: "support-actions-transfert-organisation",
    path: "/support/actions/transfert-organisation",
    meta: transfert_45organisationqYDimMG_EGB0RGoJIi6b9gyhRq7pKaYegZGQ1i9wcwAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/transfert-organisation.vue")
  },
  {
    name: "support-responsables-missions-outdated",
    path: "/support/responsables/missions-outdated",
    meta: missions_45outdatedjz1xljI0AK30xXa7Ue3vES3ciiTwVNWiiZgFcEYkQZYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/responsables/missions-outdated.vue")
  },
  {
    name: "admin-settings-rules-id-pending-items",
    path: "/admin/settings/rules/:id()/pending-items",
    meta: pending_45items3F5pG7smnY3ctcIqxvBGZirDHzG_45YFyZaIjj1PZp6w8Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/settings/rules/[id]/pending-items.vue")
  },
  {
    name: "support-actions-user-reset-context-role",
    path: "/support/actions/user-reset-context-role",
    meta: user_45reset_45context_45rolebB8iTJLK4WY3rGrVBl_XD1OZzsTl9BRsIAeA7O_z9TMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/user-reset-context-role.vue")
  },
  {
    name: "support-contents-doublons-organisations",
    path: "/support/contents/doublons-organisations",
    meta: doublons_45organisationsNNyMYzZjEjvdkuNMdF7FNTcCv63RYH1u3ZN3aIx_45iAQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/contents/doublons-organisations.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id-edit",
    path: "/admin/contenus/modeles-mission/:id()/edit",
    meta: edityJm7oYnZi_0FOADizzi8qc8sLXyVm04_Law17YNqLx0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/[id]/edit.vue")
  },
  {
    name: "inscription-benevole-step-disponibilites",
    path: "/inscription/benevole/step/disponibilites",
    meta: disponibilitesYGpxo9ejhS8OkGAonToQi4ypGiLkjOe6UGDpessNgFcMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/benevole/step/disponibilites.vue")
  },
  {
    name: "support-actions-user-reset-password-link",
    path: "/support/actions/user-reset-password-link",
    meta: user_45reset_45password_45linkPd5X_45GX2rw_6WXr5TljAchQV_v0BEG8PoLa8viCni98Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/actions/user-reset-password-link.vue")
  },
  {
    name: "admin-contenus-modeles-mission-id",
    path: "/admin/contenus/modeles-mission/:id()",
    meta: index5fIhX7EWQD_8qOuxyx_45dZomeTTfdervLuCh8A0mNXQ0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/contenus/modeles-mission/[id]/index.vue")
  },
  {
    name: "inscription-responsable-step-collectivite",
    path: "/inscription/responsable/step/collectivite",
    meta: collectivitezaJaQud9E0SVfwEyI7qAR3O1poMf47LPGjQZtd6WZHUMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/collectivite.vue")
  },
  {
    name: "inscription-responsable-step-organisation",
    path: "/inscription/responsable/step/organisation",
    meta: organisationhu7NKSZDHLoTwcxxKV6s5soubP5VndzDTPio89hmJb8Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation.vue")
  },
  {
    name: "admin-missions-id-benevoles-informations",
    path: "/admin/missions/:id()/benevoles-informations",
    meta: benevoles_45informationsmdcILwO2cDZVriAvVBp63BqznMfPKgpC82gaC7O70IkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/benevoles-informations.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-entrant",
    path: "/admin/statistics/api-engagement/trafic-entrant",
    meta: trafic_45entrantp4c6iZYPm36fJdPzZRF2mMMQoHZDWnqwrNa8md9P8H0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/api-engagement/trafic-entrant.vue")
  },
  {
    name: "admin-statistics-api-engagement-trafic-sortant",
    path: "/admin/statistics/api-engagement/trafic-sortant",
    meta: trafic_45sortant8B_45tLvUP1I4SB5l8aLvtpTveE2Ch1U_450xzhjBNOgYckMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/api-engagement/trafic-sortant.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles",
    path: "/admin/missions/:id()/trouver-des-benevoles",
    meta: indexOclN_VZhhoRAlYGzsfEEYpFgKKjGsKV9927YoKI0OZ0Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/trouver-des-benevoles/index.vue")
  },
  {
    name: "admin-statistics-departements-missions-perimees",
    path: "/admin/statistics/departements/missions-perimees",
    meta: missions_45perimeesTEJPOd_45j8K8JZWtFRvQwusqk5npaph2covR824Qg3r8Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/missions-perimees.vue")
  },
  {
    name: "admin-statistics-departements-missions-a-valider",
    path: "/admin/statistics/departements/missions-a-valider",
    meta: missions_45a_45valider4INChrSydHfFj01mGOw2jzSPGVTVSATVSJDC_45OfUiBYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/missions-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-missions-perimees",
    path: "/admin/statistics/organisations/missions-perimees",
    meta: missions_45perimeescc8AqG6Eh4fyfX_5TX_45uxFpk0GUm3g2Lhc7uxXfBNVgMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/missions-perimees.vue")
  },
  {
    name: "inscription-responsable-step-organisation-images",
    path: "/inscription/responsable/step/organisation-images",
    meta: organisation_45images5PWFJ4Z3hSkRcYYhmxedBeJbZkFgc7h4CSinSHh2bkkMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-images.vue")
  },
  {
    name: "inscription-responsable-step-organisation-details",
    path: "/inscription/responsable/step/organisation-details",
    meta: organisation_45detailsFLVcADm9UiT6cbStcz4FnT3Hx7Bu8MwyNvQJu1ZXBCYMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-details.vue")
  },
  {
    name: "support-responsables-participations-to-be-treated",
    path: "/support/responsables/participations-to-be-treated",
    meta: participations_45to_45be_45treatedtFQF1O1hI3iXYtQXvCkKOWyxxaPqGUU9rgbYFbFCNOMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/support/responsables/participations-to-be-treated.vue")
  },
  {
    name: "admin-missions-id-trouver-des-benevoles-redirect",
    path: "/admin/missions/:id()/trouver-des-benevoles/redirect",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/missions/[id]/trouver-des-benevoles/redirect.vue")
  },
  {
    name: "admin-statistics-departements-organisations-a-valider",
    path: "/admin/statistics/departements/organisations-a-valider",
    meta: organisations_45a_45validergy5rK4UTnBi3I6UmhzeiT6cJhyLTX3qk5PGN_2y3wtAMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/departements/organisations-a-valider.vue")
  },
  {
    name: "inscription-responsable-step-charte-bon-fonctionnement",
    path: "/inscription/responsable/step/charte-bon-fonctionnement",
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/charte-bon-fonctionnement.vue")
  },
  {
    name: "inscription-responsable-step-collectivite-confirmation",
    path: "/inscription/responsable/step/collectivite-confirmation",
    meta: collectivite_45confirmationK2uTw2AXNUXU6_45UejSm4JzWgwBSQIstBldnUq3JhfhoMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/collectivite-confirmation.vue")
  },
  {
    name: "inscription-responsable-step-organisation-confirmation",
    path: "/inscription/responsable/step/organisation-confirmation",
    meta: organisation_45confirmationbAowtiMk2qhmilfc9MgOC8uwppfqc781pGMegy2yYnQMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/inscription/responsable/step/organisation-confirmation.vue")
  },
  {
    name: "admin-statistics-organisations-participations-a-valider",
    path: "/admin/statistics/organisations/participations-a-valider",
    meta: participations_45a_45valider4mrXE_45fh91A4OO6w0bYh1nD4yx0_UpCk9fENzIiX3O4Meta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/participations-a-valider.vue")
  },
  {
    name: "admin-statistics-organisations-participations-refusees-annulees",
    path: "/admin/statistics/organisations/participations-refusees-annulees",
    meta: participations_45refusees_45annuleesuOedgEZPp7H8pLdplwy9907tK8CK1JW9EpAmm_45wQwVMMeta || {},
    component: () => import("/build/2550db5f-dbb3-4721-b2ba-9431b582cc3d/pages/admin/statistics/organisations/participations-refusees-annulees.vue")
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/register/volontaire/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/register/responsable/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/user/settings",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/user/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/dashboard/structure/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/dashboard/mission/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/dashboard/participation/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/dashboard/profile/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/dashboard/reseaux/:pathMatch(.*)",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/inscription/organisation",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/statistiques",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/activites/accompagnement-aux-activites-sportives",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  },
  {
    name: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60wMeta?.name,
    path: "/sitemap.xml",
    component: component_45stubsfg5uZmd_a_I2osH0p5eLCPmu8po5RNm_45rKTWLTU60w
  }
]